<template>
  <router-link v-if="hasUrl" class="cube" :to="to" @click="mapSidebar.hide()">
    <slot />
  </router-link>
</template>

<script setup>
  import { computed } from 'vue'
  import { useMapSidebar } from '@/composables/useMapSidebar.ts'

  const props = defineProps({
    to: {
      type: [Object, Boolean, null],
      required: true,
    }
  })

  const mapSidebar = useMapSidebar()
  const hasUrl = computed(() => !!props.to)
</script>